import { useQuery } from 'react-query';
import { queryKey } from 'constants/queryKey';
import { AccountSwitcherApi } from '../api/accountSwitcherApi';

export const useConnectedAccountsQuery = () => {
  return useQuery(
    queryKey.connectedAccounts(),
    () => AccountSwitcherApi.getConnectedAccounts(),
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    },
  );
};
